import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BuildDetails, BuildDetailsService } from '../models/BuildDetails';

@Injectable({ providedIn: 'root' })
export class BuildDetailsHttpService {

    constructor(
        private http: HttpClient,
        private buildDetailsService: BuildDetailsService
    ) { }

    fetchBuildDetails(): Promise<BuildDetails> {

        const httpOptions = {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache'
            })
        };

        return new Promise<BuildDetails>(
            (resolve) => {
                this.http.get<BuildDetails>('assets/build-details.json', httpOptions)
                    .toPromise()
                    .then(response => {
                        this.buildDetailsService.buildDetails = response;
                        resolve(response);
                    });
            }
        );
    }
}